export default __webpack_public_path__ + "static/media/argentan17.001ba39d.jpg";